import React from "react"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Divider from "components/atoms/Divider"
import FeedCardTitle from "components/molecules/FeedCardTitle"
import UserCard from "components/molecules/UserCard"
import { feedSummaryComponentMap } from "components/organisms/FeedCard/utils"

type FeedCardProps = {
  type: FeedType;
  children: React.ReactNode;
}

export default function FeedCard({ type, children }: FeedCardProps) {
  return feedSummaryComponentMap.hasOwnProperty(type) ? <Container>
    {children}
  </Container> : null
}

FeedCard.Title = function FeedTitle({ type, date }: { type: FeedType; date: string }) {
  return <FeedCardTitle type={type} date={date}/>
}

FeedCard.User = function FeedCardUser({ user }: { user: FeedUserDto }) {
  return user ? (
    <UserCard
      id={user.id}
      handle={user.handle}
      name={user.name}
      avatar={user.avatar}
      avatarWidth="40px"
    />
  ) : null
}

FeedCard.ContentWrapper = function FeedCardContentComponent({ children }: { children: React.ReactNode }) {
  return <Stack gap="8px">{children}</Stack>
}

FeedCard.Divider = function FeedCardDividerComponent() {
  return <Divider isFullWidth={true}/>
}

export type SummaryComponentProps<T extends FeedType> = {
  info: Extract<WishamFeed, { type: T }>;
  index: number;
};

FeedCard.Summary = function FeedCardSummaryComponent<T extends FeedType>({ type, info, index }: {
  type: T;
  info: Extract<WishamFeed, { type: T }>;
  index: number;
}) {
  const SummaryComponent = feedSummaryComponentMap[type] as React.FC<SummaryComponentProps<T>>
  return SummaryComponent ? <SummaryComponent info={info} index={index}/> : null
}

const Container = styled(Stack)(({ theme }) => ({
  backgroundColor: "#FFF",
  padding: "12px 8px",
  borderRadius: "8px",
  marginBottom: "8px",
  boxShadow: `0 0 10px 0 ${theme.palette.gray["6"]}`
}))
